import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useDurations, Duration } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<Duration>
      useData={useDurations}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
